<template>
    <div class="toasts">
        <transition-group name="fade" appear>
            <Toast v-for="toast in toasts" :key="toast.id" :toast="toast" />
        </transition-group>
    </div>
</template>

<script>
import Toast from './Toast';
import { mapState } from 'vuex';

export default {
    name: 'ToastList',
    components: {
        Toast
    },
    data() {
        return {
            interval: null
        };
    },
    computed: {
        ...mapState({
            toasts: state => state.ui.toasts
        })
    }
};
</script>

<style lang="scss" src="./ToastList.scss"></style>
